var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98987 14.6599L2.46988 13.1399C1.84988 12.5199 1.84988 11.4999 2.46988 10.8799L3.98987 9.3599C4.24987 9.0999 4.45987 8.58989 4.45987 8.22989V6.07987C4.45987 5.19987 5.17988 4.47989 6.05988 4.47989H8.20987C8.56987 4.47989 9.07988 4.26992 9.33988 4.00992L10.8599 2.4899C11.4799 1.8699 12.4999 1.8699 13.1199 2.4899L14.6399 4.00992C14.8999 4.26992 15.4099 4.47989 15.7699 4.47989H17.9199C18.7999 4.47989 19.5199 5.19987 19.5199 6.07987V8.22989C19.5199 8.58989 19.7299 9.0999 19.9899 9.3599L21.5099 10.8799C22.1299 11.4999 22.1299 12.5199 21.5099 13.1399L19.9899 14.6599C19.7299 14.9199 19.5199 15.43 19.5199 15.79V17.9399C19.5199 18.8199 18.7999 19.54 17.9199 19.54H15.7699C15.4099 19.54 14.8999 19.7499 14.6399 20.0099L13.1199 21.5299C12.4999 22.1499 11.4799 22.1499 10.8599 21.5299L9.33988 20.0099C9.07988 19.7499 8.56987 19.54 8.20987 19.54H6.05988C5.17988 19.54 4.45987 18.8199 4.45987 17.9399V15.79C4.45987 15.42 4.24987 14.9099 3.98987 14.6599Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9 15L15 9",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.4945 14.5H14.5035",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.49451 9.5H9.50349",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFees);
export default __webpack_public_path__ + "static/media/fees.e74cc301850a88b1806a8cc19879a49a.svg";
export { ForwardRef as ReactComponent };